import { takeLatest, takeEvery } from '@redux-saga/core/effects';
import { all } from 'redux-saga/effects';

import {
  CONVERSION_TOOL_COLUMNS_FETCH_START,
  CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_START,
} from '@store/conversionTool/conversionToolColumns/conversionToolColumns.const';
import {
  CONVERSION_TOOL_MAPPING_EDIT_START,
  CONVERSION_TOOL_MAPPING_FETCH_START,
} from '@store/conversionTool/conversionToolMappingEdit/conversionToolMappingEdit.const';
import {
  CONVERSION_TOOL_MAPPINGS_DELETE_REQUEST,
  CONVERSION_TOOL_MAPPINGS_FETCH_REQUEST,
} from '@store/conversionTool/conversionToolMappings/conversionToolMappings.const';
import { CREATE_MAPPING_START } from '@store/conversionTool/createMapping/createMapping.const';
import { convert } from '@store/conversionTool/postConversion/postConversion.reducer';

import { conversionToolColumnsFetchSaga } from './conversionToolColumnsFetchSaga';
import { conversionToolMappingEditSaga } from './conversionToolMappingEditSaga';
import { conversionToolMappingFetchSaga } from './conversionToolMappingFetchSaga';
import { conversionToolMappingsDeleteSaga } from './conversionToolMappingsDeleteSaga';
import { conversionToolMappingsFetchSaga } from './conversionToolMappingsFetchSaga';
import { convertRequestSaga } from './convertRequestSaga';
import { createMappingSaga } from './createMappingSaga';
import { setSelectedValuesSaga } from './setSelectedValuesSaga';

export default all([
  takeLatest(convert.type, convertRequestSaga),
  takeLatest(CONVERSION_TOOL_COLUMNS_FETCH_START, conversionToolColumnsFetchSaga),
  takeLatest(CONVERSION_TOOL_MAPPINGS_FETCH_REQUEST, conversionToolMappingsFetchSaga),
  takeEvery(CONVERSION_TOOL_MAPPINGS_DELETE_REQUEST, conversionToolMappingsDeleteSaga),
  takeLatest(CREATE_MAPPING_START, createMappingSaga),
  takeLatest(CONVERSION_TOOL_COLUMNS_SET_SELECTED_VALUES_START, setSelectedValuesSaga),
  takeLatest(CONVERSION_TOOL_MAPPING_FETCH_START, conversionToolMappingFetchSaga),
  takeLatest(CONVERSION_TOOL_MAPPING_EDIT_START, conversionToolMappingEditSaga),
]);
